import React from 'react'
import { useNavigate } from 'react-router-dom';


const Campaigns = () => {

  const navigate = useNavigate();

  return (
    <>
      <section className='w-100 px-3 pt-3 overflow-y-scroll scrollbar-hidden' style={{ backgroundColor: '#ecf6fa' }}>
        {/* Header */}
        <div className='bg-light p-3 rounded-3 d-flex align-items-center gap-3 flex-wrap'>
          <h4 className='mb-0'>Campaigns</h4>

          <select className="form-select w-auto me-auto">
            <option selected>Open this select menu</option>
            <option value="1">One</option>
            <option value="2">Two</option>
            <option value="3">Three</option>
          </select>

          <button type="button" className='btn bg-white d-flex align-items-center gap-1 shadow-sm'>
            <img src="/images/icons/dashboard-black.svg" style={{ height: '20px' }} alt="dashboard" />
            <span>Refresh</span>
          </button>

          <button type="button" className='btn btn-white shadow-sm'>Clear Draft</button>

          <button type="button" className='btn btn-primary'>Review and Publish</button>

          <button type="button" className='btn btn-white shadow-sm d-flex align-items-center justify-content-center'><img src="/images/icons/three-dot-black.svg" style={{ height: '20px' }} alt="three-dot-black" /></button>
        </div>

        {/* Search */}
        <div className='my-3 d-flex align-items-center gap-1 ps-3 bg-light rounded-3'>
          <img src="/images/icons/search-black.svg" style={{ height: '20px' }} alt="search" />
          <input type="search" className='form-control border-0 shadow-none bg-transparent' placeholder='Search...' />
        </div>

        {/* Main */}
        <div className='bg-light p-3 rounded-3'>
          {/* Buttons */}
          <div className='d-flex align-items-center gap-3 flex-wrap mb-5'>
            <button type="button" className='btn btn-primary d-flex align-items-center gap-1 shadow-sm' onClick={() => navigate(`basic-info`)}>
              <img src="/images/icons/add-white.svg" style={{ height: '20px' }} alt="dashboard" />
              <span>Create Campaign</span>
            </button>

            <button type="button" className='btn bg-white d-flex align-items-center gap-1 shadow-sm'>
              <img src="/images/icons/dashboard-black.svg" style={{ height: '20px' }} alt="dashboard" />
              <span>Copy Campaign</span>
            </button>

            <button type="button" className='btn bg-white d-flex align-items-center gap-1 shadow-sm'>
              <img src="/images/icons/dashboard-black.svg" style={{ height: '20px' }} alt="dashboard" />
              <span>Edit</span>
            </button>

            <button type="button" className='btn bg-white d-flex align-items-center gap-1 shadow-sm me-auto'>
              <img src="/images/icons/dashboard-black.svg" style={{ height: '20px' }} alt="dashboard" />
              <span>Delete</span>
            </button>

            <select className="form-select w-auto">
              <option selected>Customize Columns</option>
              <option value="1">One</option>
              <option value="2">Two</option>
              <option value="3">Three</option>
            </select>

            <select className="form-select w-auto">
              <option selected>Breakdown</option>
              <option value="1">One</option>
              <option value="2">Two</option>
              <option value="3">Three</option>
            </select>

            <button type="button" className='btn bg-white d-flex align-items-center gap-1 shadow-sm'>
              <img src="/images/icons/dashboard-black.svg" style={{ height: '20px' }} alt="dashboard" />
              <span>Export</span>
            </button>
          </div>

          {/* Table */}
          <div className='overflow-x-scroll scrollbar-hidden'>
            <table className="table">
              <thead>
                <tr>
                  <th scope="col">
                    <div className="form-check">
                      <input type="checkbox" className="form-check-input" />
                    </div>
                  </th>

                  <th scope="col">off/on</th>
                  <th scope="col">Campaign Name</th>
                  <th scope="col">Delivery</th>
                  <th scope="col">Budget</th>
                  <th scope="col">Results</th>
                  <th scope="col">Reach</th>
                  <th scope="col">Impressions</th>
                  <th scope="col">Cost per result</th>
                  <th scope="col">Amount spent</th>
                  <th scope="col">CPM (cost per 1000 Impressions)</th>
                  <th scope="col">Link clicks</th>
                  <th scope="col">CPC (cost per link clicks)</th>
                  <th scope="col">CTR (link click through rate)</th>
                  <th scope="col">Clicks (all)</th>
                  <th scope="col">CTR (all)</th>
                  <th scope="col">CPC (all)</th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td>
                    <div className="form-check">
                      <input type="checkbox" className="form-check-input" defaultChecked />
                    </div>
                  </td>

                  <td>
                    <div className="form-check form-switch">
                      <input type="checkbox" className="form-check-input" role="switch" defaultChecked />
                    </div>
                  </td>

                  <td>First Campaigns</td>
                  <td>Active</td>

                  <td className=''>
                    <span className='text-nowrap d-block'>₹ 600.00</span>
                    <small className='text-secondary'>Daily</small>
                  </td>

                  <td>
                    <span className='text-nowrap d-block'>1600</span>
                    <small className='text-secondary'>Website Visit</small>
                  </td>

                  <td>1,52,369</td>
                  <td>4,52,965</td>
                  <td>---</td>
                  <td>---</td>
                  <td>---</td>
                  <td>---</td>
                  <td>---</td>
                  <td>---</td>
                  <td>---</td>
                  <td>---</td>
                  <td>---</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section> 
    </>
  )
}

export default Campaigns;